<div>
  <div class="px-4 py-2 bg-white">
    <h1>Order Booking Health Check</h1>
    <p class="mb-0">
      List of active bookings today
      <span class="bold-text">{{ currentDate | datex : 'ddd, DD MMMM YYYY' }}</span
      >.

      <!-- The scheduled pass over the whole queue. One booking can be newer than this if it has
           been re-checked from the refresh button. -->
      <span *ngIf="data != null && data.lastUpdated">
        Checks last ran at
        <span class="bold-text">{{ data.lastUpdated | datex : 'HH:mm' }}</span
        >.
      </span>
    </p>
  </div>

  <div
    class="border-1 border-gray-100 px-4 py-2 bg-white flex gap-2 align-items-center justify-content-between"
  >
    <order-booking-tabs
      (tabChanged)="handleTabChanged($event)"
      [selectedTab]="selectedTab"
      [counts]="tabCounts"
      [loading]="isLoading"
    ></order-booking-tabs>
    <div>
      <order-booking-check-info></order-booking-check-info>
      <button
        pButton
        type="button"
        label="Unassign All"
        class="ui-button-secondary"
        (click)="unassignAll()"
        *ngIf="isUserOrderBookingHealthCheckAdmin"
      ></button>
      <button
        pButton
        type="button"
        label="Unassign Me"
        class="ui-button-secondary"
        (click)="unassignMe()"
      ></button>
    </div>
  </div>

  <div class="bg-white px-4 py-2">
    <order-booking-filters (searchClicked)="handleSearch($event)"></order-booking-filters>
  </div>

  <div *ngIf="isLoading" class="flex w-full justify-content-center my-4 bg-gray-100">
    <i class="fa fa-spin fa-spinner fa-3x"></i>
  </div>

  <div class="p-4 flex justify-content-center" *ngIf="!isLoading && data?.total === 0">
    <h4>No bookings found matching the criteria. Change the filters and try again.</h4>
  </div>

  <div class="grid grid-gap-15 px-4 py-2" *ngIf="!isLoading && data?.total > 0">
    <div class="col">
      <p-panel header="Order List ({{ data.total }})" styleClass="no-padding-panel">
        <booking-list-item
          *ngFor="let booking of paginatedBookings; let i = index; trackBy: trackByOrderId"
          [booking]="booking"
          [isSelected]="i === selectedBookingIndex"
          (selectedBookingChange)="selectBooking($event)"
        ></booking-list-item>

        <p-footer>
          <div class="flex">
            <div class="flex-grow-1">
              <p-paginator
                [rows]="pageSize"
                [totalRecords]="data.total"
                [rowsPerPageOptions]="[5, 10, 50]"
                (onPageChange)="paginate($event)"
                [alwaysShow]="false"
                [first]="pageSize * pageIndex"
              ></p-paginator>
            </div>
          </div>
        </p-footer>
      </p-panel>
    </div>
    <div class="col selected-booking-col">
      <p-panel header="Selected Booking">
        <selected-booking
          [booking]="paginatedBookings[selectedBookingIndex]"
          [rechecking]="rechecking"
          (assignedUserChange)="handleAssigneeChanged($event)"
          (issueChanged)="handleIssueChanged()"
          (recheckRequested)="recheckSelected(paginatedBookings[selectedBookingIndex]?.orderId)"
        ></selected-booking>
      </p-panel>
    </div>
  </div>
</div>

<p-confirmDialog></p-confirmDialog>
